import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import vuetify from './plugins/vuetify'
import Vuelidate from 'vuelidate'
import { Vue2Dragula } from 'vue2-dragula'
import 'dragula/dist/dragula.css'

import notifications from '@/mixins/notifications'
import AppSpinner from '@/components/AppSpinner'
import { parsePrice } from '@/utils/price'

import '@fortawesome/fontawesome-free/css/all.css'
import 'awesome-notifications/dist/style.css'
import 'awesome-notifications/dist/index.var.js'

import vClickOutside from 'v-click-outside'

Vue.use(vClickOutside)

const moment = require('moment')
require('moment/locale/si')

Vue.component('AppSpinner', AppSpinner)

Vue.use(Vuelidate)
Vue.use(Vue2Dragula)
Vue.use(require('vue-moment'), {
  moment
})

Vue.config.productionTip = false

Vue.filter('price', function (price, decPlaces) {
  return parsePrice(price, decPlaces)
})
Vue.filter('sloDate', function (date) {
  if (!date) return 'Ni podatka'
  return moment(date).format('DD.MM.YYYY')
})
Vue.filter('sloDateTime', function (date) {
  if (!date) return 'Ni podatka'
  return moment(date).format('DD.MM.YYYY HH:mm:ss')
})
Vue.filter('utcToLocal', function (date) {
  if (!date) return null
  return moment.utc(date).toDate()
})
Vue.filter('floatString', function (number) {
  const tempnumber = (number + '').replace(',', '.')
  const afterdot = tempnumber.split('.')[1]
  let num = Number.parseFloat((number + '').replace(',', '.')).toFixed(afterdot && afterdot.length ? afterdot.length : 2).replace('.', ',')
  const numLen = num.length
  if (num[numLen - 1] === '0') {
    num = num[numLen - 2] === '0' ? num.substring(0, numLen - 3) : num.substring(0, numLen - 1)
  }
  return num
})
Vue.mixin({
  ...notifications
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
